import type { UseCase } from '@/core/shared'
import type { UserRepository } from '@/core/user'

export const revokeUserInvitation: UseCase<UserRepository, 'revokeUserInvitation'> = repository => {
  return async (revokeUserInvitation) => {
    await repository.revokeUserInvitation(revokeUserInvitation)
  }
}
